import ChatboxService from '../../../../chatbox/actions/ChatboxAction';
import BotService from '../../../../chatbox/actions/ConversationAction';

function ButtonRunChatbox() {

    const { valueOpen, openIfClosed } = ChatboxService();
    const { restartConversation } = BotService();
    
    return <div className={valueOpen ? 'restart' : 'run'} onClick={() => valueOpen == false ? openIfClosed() : restartConversation()}></div>
}

export default ButtonRunChatbox